import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader } from '@mui/material';
import moment from 'moment';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import TestInfoCard from '../../../../components/TestInfoCard';
import palette from '../../../../theme/palette';
import GeneralInstruction from '../../../../components/GeneralInstruction';
import '../../../../css/upcomingTest.css';
import Header from '../../../../components/Header';
import NameAndChangeToScreenCard from '../../../../components/NameAndChangeToScreenCard';
import FileUploadIcon from '../../../../svg/FileUploadIcon';
import UploadSolution from './Student.UploadSolution';
import { GetDurationBetweenTwoDate } from '../../../../helper/commonHelper';

export default function UpcomingAssignmentDetails({ asgnDetails, onBack }) {
  const { name, startDateTime, createdAt, endDateTime, fileURL } = asgnDetails;
  const [selectedScreen, setSelScreen] = useState(null);
  const isStarted = moment(new Date()).isAfter(moment(startDateTime));
  return (
    <div style={{ marginTop: 20 }}>
      {/* eslint-disable-next-line */}
      {selectedScreen === null ? (
        <>
          <Header title={name} onBack={onBack} />
          <div className="nameAndActionContainer" style={{ justifyContent: 'center' }}>
            <div
              style={{
                borderRadius: 50,
                backgroundColor: isStarted ? '#17E21F' : palette.secondary.main,
                color: 'white',
                padding: 10,
                fontSize: 12
              }}
            >
              {isStarted
                ? 'Assignment Started'
                : `Starts in ${GetDurationBetweenTwoDate(new Date(), startDateTime)}`}
            </div>
          </div>
          {isStarted && (
            <Card sx={{ marginTop: 2 }}>
              <CardHeader title="Download the test paper" />
              <CardContent>
                <DownloadFileContainer title={fileURL} isDownload />
              </CardContent>
            </Card>
          )}
          <TestInfoCard
            createdOn={moment(createdAt).format('DD MMM, LT')}
            startTime={moment(startDateTime).format('DD MMM, LT')}
            submissionDate={moment(endDateTime).format('DD MMM, LT')}
          />
          {asgnDetails?.description && (
            <GeneralInstruction instructionList={asgnDetails?.description.split(',')} />
          )}
          {isStarted && (
            <Card sx={{ marginTop: 2 }}>
              <CardContent>
                <NameAndChangeToScreenCard
                  title="Upload Solution"
                  icon={<FileUploadIcon color={palette.secondary.main} />}
                  onClick={() => setSelScreen('upload')}
                />
              </CardContent>
            </Card>
          )}
        </>
      ) : (
        selectedScreen === 'upload' && (
          <UploadSolution onBack={() => setSelScreen(null)} startDateTime={startDateTime} />
        )
      )}
    </div>
  );
}

UpcomingAssignmentDetails.propTypes = {
  asgnDetails: PropTypes.object,
  onBack: PropTypes.func
};
